<div id="header" class="header">
  <div class="upper-part">
    <div class="content-wrapper">
      <div class="logo-space"
        [class.no-padding-top]="brandingSettings.removeLogoSpacePaddingTop"
        [style.width]="brandingSettings.logoWidth"
        [style.padding]="brandingSettings.logoPadding">
        @if (brandingSettings.logoUrl) {
          <img
            [src]="brandingSettings.logoUrl"
            class="header-logo" alt="Logo">
        }
        @if (!brandingSettings.logoUrl) {
          <img src="/assets/img/general/patientus-by-jameda.png"
            class="header-logo" alt="Logo">
        }
      </div>
      @if (!brandingSettings.removePatientusLogo && brandingSettings.logoUrl) {
        <div
          class="powered-by-space">
          <img src="/assets/img/branding/powered-by-patientus-white.svg" class="powered-by-img" alt="Logo">
        </div>
      }
      <!-- phones: opens the help sidebar (the side tab would cover the form) -->
      <button type="button" class="header-help-button" aria-controls="faq-sidebar" (click)="helpedClickHandler()">
        <i class="fas fa-question-circle" aria-hidden="true"></i>
        <span class="header-help-label">{{ 'LOGIN.FAQ-TOGGLE-TEXT' | translate }}</span>
      </button>
      @if (brandingSettings.lang && brandingSettings.lang.length > 1) {
        <div class="language-section">
          <app-translation [cssClass]="'header'"></app-translation>
        </div>
      }
    </div>
  </div>
  <div class="lower-part">
    <div class="content-wrapper">
      <p class="help-tex roboto weight-300">
            <span [innerHTML]="(brandingSettings.translationKeys?.headerSection?.[profileType()] || brandingSettings.translationKeys?.headerSection || 'HEADER-QUESTIONS.DEFAULT') | translate: {
                    faq: (brandingSettings.faqLink === false ? '' : 'HEADER-QUESTIONS.FAQ' | translate),
                    email: brandingSettings.email || ('PATIENTUS.SERVICE_EMAIL' | translate),
                    telephone: brandingSettings.telephone || ('PATIENTUS.PHONE' | translate),
                    callTime: brandingSettings.callTime || ('HEADER.TIME-AVAILABLE' | translate)
                }"></span>
      </p>
    </div>
  </div>
</div>
